import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Stack, TextField, Typography } from "@mui/material";
import CustomButton from "../../../Components/CustomButton";

export default function EditAddress({
  initialCommune,
  initialVille,
  initialPays,
  onCancel,
  onSubmit,
}) {
  const [commune, setCommune] = useState(initialCommune || "");
  const [ville, setVille] = useState(initialVille || "");
  const [pays, setPays] = useState(initialPays || "");

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCommune(initialCommune || "");
    setVille(initialVille || "");
    setPays(initialPays || "");
  }, [initialCommune, initialVille, initialPays]);

  const handleSave = async () => {
    if (!commune.trim() || !ville.trim() || !pays.trim()) {
      setError(true);
      return;
    }
    setError(false);
    setLoading(true);

    try {
      await onSubmit({
        billingCommune: commune.trim(),
        billingVille: ville.trim(),
        billingPays: pays.trim(),
      });
    } catch (e) {
      console.error(e);
    }

    setLoading(false);
  };

  return (
    <Stack spacing={2}>
      <Typography>Adresse de facturation</Typography>

      <TextField
        fullWidth
        label="Commune"
        placeholder="Ex : Cocody, Yopougon, Marcory"
        value={commune}
        onChange={(e) => setCommune(e.target.value)}
        error={error && !commune.trim()}
        helperText={error && !commune.trim() ? "La commune est obligatoire" : ""}
      />

      <TextField
        fullWidth
        label="Ville"
        placeholder="Ex : Abidjan"
        value={ville}
        onChange={(e) => setVille(e.target.value)}
        error={error && !ville.trim()}
        helperText={error && !ville.trim() ? "La ville est obligatoire" : ""}
      />

      <TextField
        fullWidth
        label="Pays"
        placeholder="Ex : Côte d'Ivoire"
        value={pays}
        onChange={(e) => setPays(e.target.value)}
        error={error && !pays.trim()}
        helperText={error && !pays.trim() ? "Le pays est obligatoire" : ""}
      />

      <Stack direction="row" justifyContent="flex-end" spacing={2}>
        <CustomButton
          type="secondaire"
          buttonText="Annuler"
          onClick={onCancel}
        />
        <CustomButton
          loading={loading}
          buttonText="Enregistrer"
          onClick={handleSave}
        />
      </Stack>
    </Stack>
  );
}

EditAddress.propTypes = {
  initialCommune: PropTypes.string,
  initialVille: PropTypes.string,
  initialPays: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
